export enum CancelUnpremoderatedVacancyModalType {
    COMPLETION = 'completion',
    DISCARD = 'discard',
}
